import { IStudentGroupingsPayload } from '../../actions/student-groupings-actions/student-groupings-actions';

// NOTE: using interface defined in student-groupings-actions,
// but not leveraging any store related code otherwise
export const generateOtherSchoolsStudentGroupingsQuery = ({ payload }: { payload: IStudentGroupingsPayload }) => {
  const { schoolId, filterKeys, groupingKey, columns } = payload;

  const columnKeys: string[] = columns.map(({ graphQlKey }) => graphQlKey);
  const filterKeysArray: string[] = filterKeys.reduce((accum: string[], key: string) => {
    if (key.includes('="')) {
      // Escape the wildcard value passed from filter dropdown, in addition to the one from rollup table
      const filterVal = key.split('=');
      const filterString = filterVal[1].replace(/\"/g, '\\"');
      accum.push(`"${filterVal[0]}=${filterString}"`);
    } else {
      accum.push(`"${key}"`);
    }
    return accum;
  }, []);

  return `{
    OtherSchoolsStudentGroupings(schoolId: "${schoolId}", otherSchoolsType: "summer", filterKeys: [${filterKeysArray}], groupingKey: "${groupingKey}", columns: ${JSON.stringify(
    columnKeys,
  )}){
        key
        human
        rowData {
          data
          meta
          columnKey
        } 
    }
  }
  `;
};

export const STUDENT_GROUPINGS_JOINS = [];
